import { render, staticRenderFns } from "./TermsListView.vue?vue&type=template&id=f7f4e9a2"
import script from "./TermsListView.vue?vue&type=script&lang=js"
export * from "./TermsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports